import { FEED_NEW_ITEMS } from "../actionTypes/actionTypes";

export function feedHasNewItems(state) {
    return [
        { type: FEED_NEW_ITEMS, state },

    ]
}